var React = require('react');

function ChevronDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.7061 0.5L6.40289 4.80407L2.09969 0.5L0.250854 2.34883L6.40289 8.5L12.5549 2.34883L10.7061 0.5Z","fill":"#16384E"}));
}

ChevronDownInline.defaultProps = {"width":"13","height":"9","viewBox":"0 0 13 9","fill":"none"};

module.exports = ChevronDownInline;

ChevronDownInline.default = ChevronDownInline;
